module.exports = __webpack_public_path__ + "static/media/press_logo_wsj.9c4c7701.jpg";